module.exports = __webpack_public_path__ + "assets/img/ja-4efc9bc0.png";